'use strict';
/**
 * Instruction setup the multi select element
 * component-name: "String" name of the component
 * is-required: "boolean" to check whether control is mandatory
 * label-field-name: "String" label field of the object in the list
 * value-field-name: "String" value field of the object in the list (this will be mandatory if "multi-select-options" "uniqueField" is not set)
 * menu-data-source: "Array" object array for the list/dropdown
 * selected-value: "Array" object array for selected the can be used as a getter also
 * no-extra-row: "boolean" no extra row for the list
 * on-item-selected: "function" bind to a function when selection is done
 * fn($event, 'crewType', operation, selectedItems)
 * params : {
 *  event: selected
 *  'identifier for element'
 *  operation returns 'ADD' 'REMOVE' or 'SET'
 *  selectedItems: returns an object array selected
 * }
 * multi-select-options: "json object to configure multi select when grouping is exist"
 * {
 *   sortBy:'value', //"String" key for sorting the array
 *  sortCategory:false, //"boolean" set whether category sorting required
 *  categoryLabel:'', // "String" key for category of the list
 *  uniqueField:'' // "String" key to set the unique key of the array
 *  }
 */

(function(){
  angular
    .module('commons')
    .directive('focusOnDrop',function($timeout) {
      return {
        restrict : 'A',
        link : function(vm,$element,$attr) {
          vm.$watch($attr.focusOnDrop,function(_focusVal) {
            $timeout(function() {
              if(_focusVal) $element[0].focus();
            });
          });
        }
      }
    })
    .directive('focusOnSearch',function($timeout) {
      return {
        restrict : 'A',
        link : function(vm,$element,$attr) {
          vm.$watch($attr.focusOnSearch,function(_focusVal) {
            $timeout(function() {
              if(_focusVal) $element[0].focus();
            });
          });
        }
      }
    })
    .component('exclusionSelectComponent',{
      templateUrl :  'commons/components/exclusion-select-component.tpl.html',
      require: {
        parent: '?form'
      },
      controller : function($timeout,$scope,$element,EventManagerService){
        var vm  = this;
        vm.isError = false;
        vm.maxH = 350;
        vm.isMoveTop = 0;
        vm.listRefreshed=false;
        var selectedInList = [];
        var multiSelectSortBy=null, categorySort=false;
        vm.drawSelection = false;
        vm.categotyMap={};
        vm.catAvailable=false;
        vm.reFocus=false;

        // Allow past dates for exclusion/inclusion date edits (audit trail captures who changes them)
        vm.exclusionDateOption = {};
        vm.lastCrewExOpenPopOver= {popOverFlag: false};
        vm.newCrewExPopover= {popOverFlag: false};

        vm.toggle = function (open) {
          if(open){
            vm.reFocus = false;
            var docH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            var eleTop = $element.offset().top;
            var itemListH = (40 * (vm.menuDataSource.length || 0));
            var realH = Math.min(itemListH, vm.maxH);
            if (eleTop +  realH> docH){
              // vm.isMoveTop = -(realH - 40);
              vm.isMoveTop = 0; // this is set to top otherwise some fields are not visible
            }
          }else{
            vm.isMoveTop = 0;
          }
        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.MULTI_SELECT_VALUE_CHANGE, function (){
          if(multiSelectSortBy!==undefined && multiSelectSortBy!==null && vm.multiSelect==='typeahead'){
            refreshMenuData();

            if(angular.isUndefined(vm.selectedValue)){
              vm.selectedValue = [0];
            }

            if(vm._menuDataSource.length>0){
              if(vm.catAvailable && !angular.isUndefined(vm.categotyMap.categoryLabel)){
                vm.selectedValue2 = createCategoryAndUpdateSelected(vm.selectedValue);
              }
              vm._menuDataSource = arrayUpdate(vm.selectedValue2, vm._menuDataSource, vm.categotyMap.uniqueKey, 'startedDate', vm.categotyMap.categoryLabel);
              vm._menuDataSource = arrayUpdate(vm.selectedValue2, vm._menuDataSource, vm.categotyMap.uniqueKey, 'changed', vm.categotyMap.categoryLabel);
              vm.selectedValue2 = addSelected(vm.selectedValue2, true);
              vm._menuDataSource = arrayUpdate(vm.selectedValue2, vm._menuDataSource, vm.categotyMap.uniqueKey, 'selected', vm.categotyMap.categoryLabel);

            }
          }
        });

        function refreshMenuData() {
          angular.forEach(vm._menuDataSource, function (menu) {
            menu.selected =false;
            if(!angular.isUndefined(menu.childElements)){
              angular.forEach(menu.childElements, function (child) {
                child.selected = false;
              })
            }
          })
        }


        function createCategoryAndUpdateSelected(selectedList) {
          var createdSelected = [];
          _.each(selectedList, function (selected) {
            _.each(vm._menuDataSource, function (category) {
              var found = _.find(category[vm.categotyMap.categoryLabel], function(inCategory){
                return (selected[vm.categotyMap.uniqueKey] === inCategory[vm.categotyMap.uniqueKey]) ? true : false;
              });
              if(!angular.isUndefined(found)){
                var catFound = _.find(createdSelected, function(ccat){
                  if(ccat[vm.valueFieldName] == category[vm.valueFieldName]){
                    return ccat[vm.valueFieldName];
                  }
                });
                if(!angular.isUndefined(catFound)){
                  catFound[vm.categotyMap.categoryLabel].push(selected);
                }else{
                  var cat = {};
                  cat[vm.valueFieldName] = category[vm.valueFieldName];
                  cat[vm.labelFieldName] = category[vm.labelFieldName];
                  // cat[vm.startedDate] = category[vm.startedDate];
                  cat[vm.categotyMap.categoryLabel] = [];
                  cat[vm.categotyMap.categoryLabel].push(selected);
                  createdSelected.push(cat);
                }
              }
            });
          });
          return createdSelected;
        }

        vm.stop = function (event) {
          event.stopPropagation();
        };

        vm.onItemClick = function(item,$event){
          vm.selectedValue = item;
          $timeout(function(){
            var option = {
              selectedItem:vm.selectedValue
            };
            vm.onItemSelected(option);
            checkRequired();
          },0);

          vm.isOpen = false;

          if(angular.isDefined($event)){
            $event.preventDefault();
            $event.stopPropagation();
          }


        };

        vm.filterBy = function (viewVal) {
          selectedInList = [];
          if(angular.isUndefined(vm.categotyMap.categoryLabel) || vm.searchBy === 'parentNode' ){
            selectedInList = angular.copy(vm._menuDataSource).filter(function(item) {
              return item[vm.labelFieldName].toLowerCase().indexOf($.trim(viewVal).toLowerCase()) > -1;
            });
          }else{
            angular.forEach(angular.copy(vm._menuDataSource), function(list){
              list[vm.categotyMap.categoryLabel] = list[vm.categotyMap.categoryLabel].filter(function(item) {
                return item[vm.labelFieldName].toLowerCase().indexOf($.trim(viewVal).toLowerCase()) > -1;
              });
              if(list[vm.categotyMap.categoryLabel].length>0){
                selectedInList.push(list);
              }
            });
          }
          angular.forEach(angular.copy(vm._menuDataSource), function(item){
            if(item.selected == true){
              var flag = 0;
              angular.forEach(angular.copy(selectedInList), function(selected){
                if(flag == 0 && item[vm.labelFieldName] == selected[vm.labelFieldName]){
                  flag = 1;
                }
              })
              if(flag == 0)
                selectedInList.push(item);
            }
          });
          return selectedInList;
        };

        vm.assignAll = function () {
          angular.forEach(selectedInList, function (assigns) {
            assigns.selected = true;
            assigns.changed = true;
            changeStatusSubItems(assigns.selected, assigns[vm.categotyMap.categoryLabel]);
          });
          vm.disableExclusionSave = false;
        };

        vm.unAssignAll = function () {
          angular.forEach(selectedInList, function (assigns) {
            assigns.selected = false;
            assigns.changed = false;
            changeStatusSubItems(assigns.selected, assigns[vm.categotyMap.categoryLabel]);
          });
          vm.disableExclusionSave = false;
        };

        vm.doneSelection = function () {
          vm._menuDataSource = arrayUpdate(selectedInList, vm._menuDataSource, vm.categotyMap.uniqueKey, 'selected', vm.categotyMap.categoryLabel);
          vm._menuDataSource = arrayUpdate(selectedInList, vm._menuDataSource, vm.categotyMap.uniqueKey, 'changed', vm.categotyMap.categoryLabel);
          vm._menuDataSource = arrayUpdate(selectedInList, vm._menuDataSource, vm.categotyMap.uniqueKey, 'startedDate', vm.categotyMap.categoryLabel);
          vm.selectedValue = getSelectedItems(vm._menuDataSource, 'selected', vm.categotyMap.categoryLabel);
          vm.drawSelection = true;
          setSelectedItems($.Event("click"), 'SET');
          closePopup()
        };

        vm.closePopup = function(){
          closePopup()
        };



        function arrayUpdate(formArr, toArr, flag, updateFlag, subCategory) {
          _.each(formArr, function (_selected) {
            var toUpdate = _.find(toArr, function(xObj){
              return xObj[flag] === _selected[flag];
            });
            if(!angular.isUndefined(toUpdate)){
              toUpdate[updateFlag] = _selected[updateFlag];
              if(!!toUpdate[subCategory]){

                _.each(_selected[subCategory],function(subCategoryItem){
                  _.each(toUpdate[subCategory],function(subCategoryItemToUpdate){
                    if(subCategoryItemToUpdate[flag]===subCategoryItem[flag]){
                      subCategoryItemToUpdate[updateFlag] = subCategoryItem[updateFlag];
                    }
                  });
                });
              }
            }
          });
          return toArr;
        }

        function getSelectedItems(formArr, flag, subCategory) {
          var spa = [];
          _.each(formArr, function (_selected) {
            if(!!_selected[subCategory]){
              var getA = _.filter(_selected[subCategory], function (xObj) {
                return xObj[flag] === true;
              });
              spa = spa.concat(getA);
            }else{
              if(_selected[flag]){
                spa.push(_selected);
              }
            }
          });
          return spa;
        }

        function closePopup(){
          $timeout(function(){
            var e = $.Event("keydown");
            e.which = 27;
            angular.element('.type-a-head-ele').trigger(e);
          });
        }

        function changeStatusSubItems(flag, subSet) {
          angular.forEach(subSet, function (item) {
            item.selected = flag;
            item.startedDate = null;
            item.changed = flag;
          });
        }

        function changeStatusOfParent(_item, updateSource) {
          var updateValue = selectedInList;
          if(updateSource){
            updateValue = vm._menuDataSource;
          }
          for(var i=0;i<updateValue.length;i++){
            var category = updateValue[i];
            var t = {};
            t[vm.categotyMap.uniqueKey] = _item[vm.categotyMap.uniqueKey];
            var found = _.find(category[vm.categotyMap.categoryLabel], t);
            if(!angular.isUndefined(found)){
              if(_item.selected){
                category.selected = true;
                found.selected = true;
                found.startedDate = _item.startedDate;
                found.changed = _item.changed;

              }else{
                var anySelected = _.findIndex(category[vm.categotyMap.categoryLabel], {selected:true});
                category.selected = anySelected > -1;
              }
              break;
            }
          }
        }

        function setSelectedItems($event, operation) {
          angular.forEach(vm.selectedValue, function (exclusion) {
            if ( exclusion.startedDate === null) {
              var month = new Date().getMonth()+1;
              exclusion.startedDate = new Date().getDate()+"/"+month+"/"+new Date().getFullYear();
            }

          });
          var option = {
            $event:$event,
            selectedItems: vm.selectedValue,
            operation:operation
          };
          vm.onItemSelected(option);
        }

        vm.selectAnItem = function (data, label) {
          if('category' === label.toLowerCase()){
            data.selected = !data.selected;
            changeStatusSubItems(data.selected, data[vm.categotyMap.categoryLabel]);
          }else{
            data.selected = !data.selected;
            data.changed = true;
            changeStatusOfParent(data, false);
          }
          vm.disableExclusionSave = false;
        };

        vm.setSelected = function ($item, $model, $label, $event) {
          $item.selected = false;
          setSelectedItems($event, 'ADD');
          changeStatusOfParent($item, false);
        };

        vm.removeFromList = function (event, item, label) {
          if('category' === label.toLowerCase()){
            item.selected = false;
            changeStatusSubItems(item.selected, item[vm.categotyMap.categoryLabel]);
          }else{
            item.selected = false;
            item.startedDate = null;
            changeStatusOfParent(item, true);
          }
          vm.selectedValue = getSelectedItems(vm._menuDataSource, 'selected', vm.categotyMap.categoryLabel);
          vm.disableExclusionSave = false;
          setSelectedItems(event, 'REMOVE');
        };

        vm.openList = function () {
          vm._menuDataSource = angular.copy(vm.codyMaster);
        };

        vm.$onChanges = function (changeObj) {
          if(changeObj.menuDataSource && changeObj.menuDataSource &&
            (changeObj.menuDataSource.currentValue !== changeObj.menuDataSource.previousValue)){
            if(vm.multiSelect==='typeahead'){
              if(!angular.isUndefined(changeObj.menuDataSource.currentValue)){
                vm.codyMaster = angular.copy(changeObj.menuDataSource.currentValue);
                setMultiSelectOptions();
                listSort();
              }

            }else{
              vm.listRefreshed = true;
            }

          }
        };

        vm.onClickExcludeCrewEditDate = function (e, exCrew, type) {
          angular.forEach(vm.selectedValue, function (value) {
            if (vm.crewExclusionPopOver && value.labelFieldName === exCrew.labelFieldName && value.labelFieldName === vm.crewExclusionPopOver.labelFieldName) {
              if (vm.crewExclusionPopOver.startedDate !== exCrew.startedDate) {
                if (vm.crewExclusionPopOver.startedDate === "") {
                  value.startedDate = exCrew.startedDate;
                  value.changed = true;
                } else {
                  value.startedDate = vm.crewExclusionPopOver.startedDate;
                  value.changed = true;
                }
                vm.disableExclusionSave = false;
              }
            }
            changeStatusOfParent(value,true);
          });



          vm.lastCrewExOpenPopOver.popOverFlag = false;
          vm.newCrewExPopover.popOverFlag = false;
          vm.crewExclusionPopOver = {};
          vm.crewExclusionPopOver.updateType = 'Edit';
          vm.crewExclusionPopOver.startedDate = exCrew.startedDate;
          vm.crewExclusionPopOver.labelFieldName = exCrew.labelFieldName;
          exCrew.popOverFlag = true;

          vm.lastCrewExOpenPopOver = exCrew;
        };

        $scope.$watch('vm.selectedValue',function(newVal,oldVal){
          checkRequired();
        });


        function setMultiSelectOptions() {
          multiSelectSortBy = vm.labelFieldName;
          vm.categotyMap.uniqueKey = vm.labelFieldName;
          if(!angular.isUndefined(vm.valueFieldName)){
            multiSelectSortBy = vm.valueFieldName;
            vm.categotyMap.uniqueKey = vm.valueFieldName;
          }
          if(!angular.isUndefined(vm.multiSelectOptions)){
            if (!angular.isUndefined(vm.multiSelectOptions.sortBy)){
              multiSelectSortBy = vm.multiSelectOptions.sortBy;
            }
            if (!angular.isUndefined(vm.multiSelectOptions.categoryLabel)){
              vm.categotyMap.categoryLabel = vm.multiSelectOptions.categoryLabel;
              vm.catAvailable = true;
            }
            if (!angular.isUndefined(vm.multiSelectOptions.uniqueField)){
              vm.categotyMap.uniqueKey = vm.multiSelectOptions.uniqueField;
            }
            if(!angular.isUndefined(vm.multiSelectOptions.sortCategory)){
              categorySort = vm.multiSelectOptions.sortCategory;
            }
          }
        }

        var addSelected = function (array, toBeSet) {
          return _.map(array, function(element) {
            if(!angular.isUndefined(element[vm.categotyMap.categoryLabel]) && !!element[vm.categotyMap.categoryLabel]){
              element[vm.categotyMap.categoryLabel] = addSelected(element[vm.categotyMap.categoryLabel], toBeSet);
            }
            return _.extend({}, element, {selected: toBeSet});
          });
        };

        function listSort() {

          var sortSelected = function (_array) {
            var returnArray = _array;
            if(!!multiSelectSortBy){
              if(categorySort){
                returnArray = _.sortBy(_array, function(element){
                  if(!angular.isUndefined(element[vm.categotyMap.categoryLabel]) && !!element[vm.categotyMap.categoryLabel]) {
                    element[vm.categotyMap.categoryLabel] = sortSelected(element[vm.categotyMap.categoryLabel]);
                  }
                  return element[multiSelectSortBy];
                });
              }else{
                returnArray = _.each(_array, function(element){
                  if(!angular.isUndefined(element[vm.categotyMap.categoryLabel]) && !!element[vm.categotyMap.categoryLabel]) {
                    element[vm.categotyMap.categoryLabel] = _.sortBy(element[vm.categotyMap.categoryLabel], function (item) {
                      return item[multiSelectSortBy];
                    });
                  }
                });
              }
            }
            return returnArray;
          }

          if(multiSelectSortBy!==undefined){
            vm.codyMaster = addSelected(vm.codyMaster, false);
            vm.selectedValue = addSelected(vm.selectedValue, true);
            vm._menuDataSource = sortSelected(vm.codyMaster);
            createSelectedList()
          }
        }

        function createSelectedList() {
          if(vm.selectedValue.length>0) {
            if (!angular.isUndefined(vm.categotyMap.categoryLabel)) {
              _.each(vm.selectedValue, function (_item) {
                changeStatusOfParent(_item, true);
              });
            }else{
              vm._menuDataSource = arrayUpdate(vm.selectedValue, vm._menuDataSource, vm.categotyMap.uniqueKey, 'selected', vm.categotyMap.categoryLabel);
            }
          }
        }

        function checkRequired(){
          if(vm.isRequired){
            if(angular.isUndefined(vm.selectedValue) || vm.selectedValue == null || (typeof vm.selectedValue == 'string' && vm.selectedValue.trim().length == 0) ){
              vm.isError = true;
            } else{
              vm.isError = false;
            }
          }
        }

      },
      bindings : {
        indexTab:'=',
        isRequired : '=',
        componentName : '@',
        labelFieldName : '@',
        valueFieldName :'@',
        selectedValue : '=',
        menuDataSource : '<',
        onItemSelected : '&',
        isDisable : '=',
        wrappedForm : '=',
        noExtraRow:'=',
        multiSelect: '@',
        multiSelectOptions: '=',
        searchPanelToggle: '=',
        disableExclusionSave : '=',
        searchBy:'@'
      }
    });
})();
